<template>
  <el-button
    v-loading="loading"
    :class="{ favorite: true, active}"
    icon="icon-heart"
    :circle="circle"
    @click="user ? toggleFavorite() : $router.push({ name: 'Welcome' })"
  />
</template>
<script>
  import { mapState } from 'vuex';
  import ResourcePage from '@/components/Core/ResourcePage';

  export default {
    extends: ResourcePage,
    props: {
      value: {
        type: Object,
        default: null,
      },
      entityId: {
        required: true,
        default: 0,
        type: Number,
      },
      entityName: {
        required: true,
        type: String,
      },
      circle: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        active: false,
      };
    },
    computed: {
      ...mapState({
        user: state => state.auth.user,
      }),
    },
    watch: {
      value(val) {
        this.active = !!val;
      },
    },
    mounted() {
      this.active = !!this.value;
    },
    methods: {
      toggleFavorite() {
        // this.loading = true;
        const prevValue = this.value;
        if (this.value) {
          this.$emit('input', null);
          this.provider.remove(this.value.id)
            .then(() => {
              // this.loading = false;
              this.$emit('reloadList', true);
            })
            .catch(() => {
              this.$emit('input', prevValue);
              // this.loading = false;
            });
        } else {
          this.$emit('input', {});
          this.provider.add({
            user_id: this.user.id,
            [this.entityName]: this.entityId,
          })
            .then(({ data }) => {
              // this.loading = false;
              this.$emit('input', data);
              this.$emit('reloadList', true);
            })
            .catch(() => {
              this.$emit('input', prevValue);
              // this.loading = false;
            });
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Core/Favorite.vue